import {observable} from "mobx";
import api from "../Services/Api";

class PermissionsStore {
    @observable useTemplates = false;
    @observable useTemplatesV2 = false;
    @observable allowAvitoAccounts = false;
    @observable allowDictionaries = false;
    async load() {
        const result = await api.get('user/permissions');
        if (result.success) {
            this.useTemplates = result.data.useTemplates;
            this.useTemplatesV2 = result.data.useTemplatesV2;
            this.allowAvitoAccounts = result.data.allowAvitoAccounts;
            this.allowDictionaries = result.data.allowDictionaries;
        }
    }
}

const permissionsStore = new PermissionsStore();
export default permissionsStore;